var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGauge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9922 27.998L31.9922 19.998",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.68 37.9989C4.92444 34.9586 4.00013 31.5096 4 27.9988C3.99987 24.488 4.92391 21.039 6.67924 17.9985C8.43457 14.958 10.9593 12.4331 13.9998 10.6777C17.0402 8.92222 20.4892 7.99805 24 7.99805C27.5108 7.99805 30.9598 8.92222 34.0002 10.6777C37.0407 12.4331 39.5654 14.958 41.3208 17.9985C43.0761 21.039 44.0001 24.488 44 27.9988C43.9999 31.5096 43.0756 34.9586 41.32 37.9989",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGauge);
export default __webpack_public_path__ + "static/media/gauge.5fa38e0f1f499a5fece480bd1aa74fe7.svg";
export { ForwardRef as ReactComponent };